import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ProofStrip } from "@/components/ProofStrip";
import { ClosingCTA } from "@/components/ClosingCTA";
import { FeaturesSection } from "@/components/FeaturesSection";
// Testimonials temporarily hidden from the public landing page.
// import { TestimonialsSection } from "@/components/TestimonialsSection";
import { HowItWorks } from "@/components/HowItWorks";
// Pricing is temporarily hidden from the public site while we run the Meta ads
// demo-booking campaign. Preserve the import/route in case we revive it later.
// import { PricingSection } from "@/components/PricingSection";
import { FAQSection } from "@/components/FAQSection";
import { Footer } from "@/components/Footer";
import LoaderScreen from "@/components/LoaderScreen";
import { routeLoggedInUserFromPublicPage } from "@/utils/signupFunnelRedirect";
import { clearQuickUploadOpen, markQuickUploadOpen, quickUploadDialogRequested } from "@/lib/quickUpload";
import { QuickUploadDialog } from "@/pages/QuickUpload";
import { applyPageMeta, HOME_SEO } from "@/lib/seo";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Index = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [portalRedirectPending, setPortalRedirectPending] = useState(true);
  const [uploadOpen, setUploadOpen] = useState(false);

  useEffect(() => {
    const open = () => {
      markQuickUploadOpen();
      setUploadOpen(true);
      setPortalRedirectPending(false);
    };
    window.addEventListener("statbox-quick-upload-open", open);
    return () => window.removeEventListener("statbox-quick-upload-open", open);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const params = new URLSearchParams(location.search);
    if (params.get("upload") === "1") markQuickUploadOpen();

    (async () => {
      let handled = false;
      try {
        handled = await routeLoggedInUserFromPublicPage(navigate);
        if (cancelled || handled) return;
      } catch (err) {
        console.warn("Index: could not route logged-in user", err);
      }
      if (cancelled) return;
      if (quickUploadDialogRequested()) setUploadOpen(true);
      setPortalRedirectPending(false);
      if (params.get("upload") === "1") {
        navigate("/", { replace: true });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate, location.search]);

  useEffect(() => {
    const scrollTo = (location.state as { scrollTo?: string })?.scrollTo;
    if (!scrollTo) return;

    // Consume the scroll hint immediately so a hard refresh (which preserves
    // window.history.state) doesn't replay the smooth-scroll into the second
    // section every time and visually "skip" the hero.
    navigate(location.pathname, { replace: true, state: null });

    const timer = setTimeout(() => {
      document.getElementById(scrollTo)?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
    return () => clearTimeout(timer);
  }, [location.state, location.pathname, navigate]);

  useEffect(() => {
    applyPageMeta(HOME_SEO);
  }, []);

  if (portalRedirectPending) {
    return <LoaderScreen delay={0} subtitle="Taking you to your portal…" />;
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <main>
        <Hero />
        <ProofStrip />
        {/* Testimonials hidden from public landing page. */}
        {/* <TestimonialsSection /> */}
        <FeaturesSection />
        <HowItWorks />
        <FAQSection />
        <ClosingCTA />
        <Footer />
      </main>
      <QuickUploadDialog
        open={uploadOpen}
        onClose={() => {
          clearQuickUploadOpen();
          setUploadOpen(false);
        }}
      />
    </div>
  );
};

export default Index;
